import React from "react";
import PropTypes from "prop-types";
import { Formik } from "formik";
import * as Yup from "yup";
import { find } from "lodash";
import Grid from "@mui/material/Grid";
import {
  AutoSaveField as Field,
  CustomSelect,
  Input,
  SelectAutocomplete
} from "../../../../../../components/Form";

import { ContinueButton } from "../../../../../../components/Buttons/ContinueButton";
import { ButtonWrapper, StyledDivider as Divider } from "./styled";
import { documentUnique, downloadableDocsData } from "../../../../../../constants/documents";
import { RoDocument } from "../../../../../UploadDocuments/components/RoDocument/RoDocument";
import { FormContainer } from "../CompanyBusinessRelationships/styled";
import { ScrollToError } from "components/ScrollToError";

const additionalSecuritySchema = () =>
  Yup.object().shape({
    additionalSecurity: Yup.string().max(10, "Maximum 10 characters allowed"),
    additionalSecurityOptions: Yup.array(),
    Remarks: Yup.string().nullable()
  });

const intialSchema = {
  additionalSecurity: "",
  additionalSecurityOptions: [],
  Remarks: ""
};

export const AdditionalSecurityComponent = ({ handleContinue }) => {
  return (
    <Formik
      initialValues={intialSchema}
      onSubmit={handleContinue}
      validationSchema={additionalSecuritySchema}
      validateOnChange={false}
    >
      {({ values, setFieldValue }) => {
        return (
          <FormContainer>
            <ScrollToError />
            <Grid container spacing={3}>
              <Grid item sm={8} xs={12}>
                <Field
                  path={
                    "roProspect.organizationInfoRO.additionalSecurityDetails.additionalSecurity"
                  }
                  name="additionalSecurity"
                  label="Additional Security"
                  component={CustomSelect}
                  datalistId="YesNoList"
                />
              </Grid>
              <Grid item sm={8} xs={12}>
                <Field
                  multiple
                  path={
                    "roProspect.organizationInfoRO.additionalSecurityDetails.additionalSecurityType"
                  }
                  name="additionalSecurityOptions"
                  label="Additional Security Options"
                  component={SelectAutocomplete}
                  datalistId="additionalSecurity"
                  disabled={values.additionalSecurity !== "Yes"}
                  onChange={selectedValue => {
                    const withOthers = selectedValue.includes("Others");
                    const Remarks = withOthers ? values.Remarks : "";
                    const securityOptions = selectedValue.map(value => ({
                      securityType: value,
                      others: Remarks
                    }));
                    setFieldValue("additionalSecurityOptions", securityOptions);
                  }}
                  extractValue={value => value.securityType}
                />
              </Grid>
              {find(values.additionalSecurityOptions, { securityType: "Others" }) && (
                <Grid item sm={8} xs={12}>
                  <Field
                    path={
                      "roProspect.organizationInfoRO.additionalSecurityDetails.additionalSecurityType[0].others"
                    }
                    name="Remarks"
                    label="Remarks"
                    placeholder="Remarks"
                    component={Input}
                    rows="2"
                  />
                </Grid>
              )}

              <Divider />
              <Grid item sm={12} xs={12}>
                <RoDocument
                  uniqueId={documentUnique.AdditionalSecurityDocuments}
                  downloadUrl={downloadableDocsData[documentUnique.AdditionalSecurityDocuments].url}
                  downloadLabel={
                    downloadableDocsData[documentUnique.AdditionalSecurityDocuments].title
                  }
                />
              </Grid>
            </Grid>

            <ButtonWrapper>
              <ContinueButton type="submit" />
            </ButtonWrapper>
          </FormContainer>
        );
      }}
    </Formik>
  );
};

AdditionalSecurityComponent.propTypes = {
  /**
   * Function to handle form submission and continue to next step
   */
  handleContinue: PropTypes.func.isRequired
};
